// Modules
import { hash, compare } from "bcryptjs";
import { createCipheriv, createDecipheriv } from "crypto";

/**
 * Hashes the password.
 *
 * @param {String} password the raw password
 * @returns the password hashed
 */
export async function hashPassword(password) {
    const hashedPassword = await hash(password, 12);

    return hashedPassword;
}

/**
 * Verifies a password against the hashed password.
 *
 * @param @param {String} password the raw password
 * @param {*} hashedPassword the hashed password
 * @returns true if the password is valid, false otherwise
 */
export async function verifyPassword(password, hashedPassword) {
    const isValid = await compare(password, hashedPassword);

    return isValid;
}

const ENCRYPT_ALGORITHM = "aes-256-ctr";
const ENCRYPT_IV = Buffer.from(process.env.NEXT_PUBLIC_SECRET_KEY_IV);
const ENCRYPT_SECRET_KEY = Buffer.from(process.env.NEXT_PUBLIC_SECRET_KEY);

/**
 * Encrypts a text.
 *
 * @param {String} textToEncrypt text to encrypt
 * @returns the text encrypted
 */
export async function encrypt(textToEncrypt) {
    const cipher = createCipheriv(ENCRYPT_ALGORITHM, ENCRYPT_SECRET_KEY, ENCRYPT_IV);

    const encryptedText = Buffer.concat([cipher.update(textToEncrypt), cipher.final()]);

    return encryptedText.toString("hex");
}

/**
 * Decrypts a text.
 *
 * @param {String} encryptedTextStr text to decrypt
 * @returns the text decrypted
 */
export async function decrypt(encryptedTextStr) {
    const encryptedText = Buffer.from(encryptedTextStr, "hex");

    const decipher = createDecipheriv(ENCRYPT_ALGORITHM, ENCRYPT_SECRET_KEY, ENCRYPT_IV);

    const decryptedText = Buffer.concat([decipher.update(encryptedText), decipher.final()]);

    return decryptedText.toString();
}
